import React from 'react';
import './Footer.css'; // Import the CSS file

const Footer = () => {
  return (
    <footer className="main-footer">
      <p>&copy; {new Date().getFullYear()} Jack Mayr. All rights reserved.</p>
      <p>
        <a href="https://github.com/JackMayr2" target="_blank" rel="noopener noreferrer">
          GitHub
        </a>{' '}
        |{' '}
        <a href="https://www.linkedin.com/in/jack-mayr-912486168/" target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
      </p>
    </footer>
  );
};

export default Footer;